class ImageReplacement {
  constructor(imagesClass, containerClass, replacementTarget) {
    this.imagesClass = imagesClass;
    this.containerClass = containerClass;
    this.replacementTarget = replacementTarget;
  }
  run() {
    const images = document.querySelectorAll(this.imagesClass);
    if (!images) return;
    images.forEach((img) => {
      img.addEventListener("click", (e) => {
        e.preventDefault();
        const target = e.target;
        const image_url = target.dataset.mainimage;
        const wrapper = target.closest(this.containerClass);

        wrapper.querySelector(this.replacementTarget).src = image_url;
        this.replace(wrapper.querySelectorAll(this.imagesClass), img);
      });
    });
  }
  replace(imgList, target) {
    imgList.forEach((img) => {
      img.classList.remove("current");
    });
    target.classList.add("current");
  }
}

class PhotoScroll {
  constructor(slideClass, button, distance) {
    this.slideClass = slideClass;
    this.button = button;
    this.distance = distance;
  }
  run() {
    const placeSlides = document.querySelector(this.slideClass);
    const switchButton = document.querySelectorAll(this.button);
    if (!placeSlides || !switchButton) return;

    this.height_check(placeSlides, switchButton);

    switchButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const target = e.target;
        const scrollAmount = target.classList.contains("down") ? this.distance : - this.distance;

        placeSlides.scrollBy({
          top: scrollAmount,
          behavior: "smooth"
        });
      });
    });

    placeSlides.addEventListener("scroll", () => {
      this.height_check(placeSlides, switchButton);
    });

    window.addEventListener("resize", () => {
      this.height_check(placeSlides, switchButton);
    });
  }
  height_check(placeSlides, switchButton) {
    if (placeSlides.clientHeight >= placeSlides.scrollHeight) {
      switchButton.forEach((button) => {
        button.classList.add("disable");
      });
      return;
    };

    switchButton.forEach((button) => {
      button.classList.remove("disable");
    });

    if (placeSlides.scrollTop + placeSlides.clientHeight == placeSlides.scrollHeight) {
      switchButton.forEach((button) => {
        button.classList.contains("down") && button.classList.add("disable");
      });
    }

    if (placeSlides.scrollTop == 0) {
      switchButton.forEach((button) => {
        button.classList.contains("up") && button.classList.add("disable");
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ImageReplacement(".image-replacement", ".image-container", ".main-image > img").run();
});
window.addEventListener("pageshow", () => {
  new PhotoScroll(".place-slides", ".switch-button", 84).run();
});
